const getTimestamp = (value) => {
    if (!value) return 0;

    // Try native Date parsing first
    const d = new Date(value);
    if (!isNaN(d.getTime())) {
        return d.getTime();
    }

    // Fallback for YYYY-MM-DD
    if (typeof value === 'string' && value.includes('-')) {
        const [y, m, day] = value.split('-');
        const dd = new Date(parseInt(y), parseInt(m) - 1, parseInt(day));
        if (!isNaN(dd.getTime())) return dd.getTime();
    }

    return 0;
};

const usePatientNotesTimeline = ({
    notes,
    notesLoading,
    notesError,
    whatsappMessages,
    whatsappMessagesLoading,
    whatsappMessagesError,
    operations,
    operationsLoading,
    operationsError,
}) => {
    const timelineEntries = [
        ...(Array.isArray(notes) ? notes.map((n) => ({ kind: 'note', ts: getTimestamp(n.date), data: n })) : []),
        ...(Array.isArray(whatsappMessages)
            ? whatsappMessages.map((m) => ({ kind: 'message', ts: getTimestamp(m.time_to_send), data: m }))
            : []),
        ...(Array.isArray(operations)
            ? operations.map((o) => ({ kind: 'operation', ts: getTimestamp(o.date), data: o }))
            : []),
    ].sort((a, b) => a.ts - b.ts);

    const isTimelineLoading = !!notesLoading || !!whatsappMessagesLoading || !!operationsLoading;
    const timelineError = notesError || whatsappMessagesError || operationsError;

    return {
        timelineEntries,
        isTimelineLoading,
        timelineError,
    };
};

export default usePatientNotesTimeline;
